module.exports = __webpack_public_path__ + "img/30.279fcf29.jpg";